import { MemberDetailsDto } from '../listtones/memberdetailsdto';

export interface ViewBlacklistDto
{
    getClientTxnId(): string;
    getLanguage(): string;
    getServiceId(): string;
    getActivityId(): string;
    getAPartyMsisdn(): string;
    getChannelId(): string;
    getRbtMode(): string;

    getMemberDetails(): MemberDetailsDto[];
}

export class ViewBlacklistDtoImpl implements ViewBlacklistDto
{
    private clientTxnId: string;
    private language: string;
    private serviceId: string;
    private activityId: string;
    private aPartyMsisdn: string;
    private channelId: string;
    private rbtMode: string;
    private memberDetails: MemberDetailsDto[];

    getClientTxnId(): string
    {
        return this.clientTxnId;
    }
    setClientTxnId(clientTxnId: string)
    {
        this.clientTxnId = clientTxnId;
    }

    getLanguage(): string
    {
        return this.language;
    }
    setLanguage(language: string)
    {
        this.language = language;
    }

    getServiceId(): string
    {
        return this.serviceId;
    }
    setServiceId(serviceId: string)
    {
        this.serviceId = serviceId;
    }

    getActivityId(): string
    {
        return this.activityId;
    }
    setActivityId(activityId: string)
    {
        this.activityId = activityId;
    }

    getAPartyMsisdn(): string
    {
        return this.aPartyMsisdn;
    }
    setAPartyMsisdn(aPartyMsisdn: string)
    {
        this.aPartyMsisdn = aPartyMsisdn;
    }

    getChannelId(): string
    {
        return this.channelId;
    }
    setChannelId(channelId: string)
    {
        this.channelId = channelId;
    }

    getRbtMode(): string
    {
        return this.rbtMode;
    }
    setRbtMode(rbtMode: string)
    {
        this.rbtMode = rbtMode;
    }

    setMemberDetails(memberDetails: MemberDetailsDto[])
    {
        this.memberDetails = memberDetails;
    }
    getMemberDetails(): MemberDetailsDto[] 
    {
        return this.memberDetails;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/viewblacklist/viewblacklistdto.ts